// AUTO-GENERATED by scripts/generate-version.js. Do not edit by hand.
export default Object.freeze({
    "version": "v2026-07-23-13-09-00-1-g6b3cf56",
    "packageVersion": "0.1.0",
    "commit": "6b3cf56",
    "branch": "deploy/new-customer-install",
    "buildTime": "2026-07-27T15:34:11.271Z"
});
